import React, { useEffect, useState } from 'react';
import Section from '../Section';
import BlogSectionStyle2 from '../Section/BlogSection/BlogSectionStyle2';
import Breadcrumb from '../Breadcrumb';
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import axios from 'axios';
import { pageTitle } from '../../helpers/PageTitle';
import { BASE_URL } from "../../helpers/api"; // ✅ add this

export default function Blog() {
  pageTitle('Blog');

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/blogs`)   // ✅ fixed
      .then(res => {
        const list = Array.isArray(res.data) ? res.data : [];
        setBlogs(list);
      })
      .catch(err => {
        console.log("Blog Fetch Error:", err);
      });
  }, []);

  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
        imgUrl="/images/blog/blog.jpg"
        title="Blog"
        subTitle=""
        style={{ minHeight: "535px" }}
      />

      <Section topMd={85} topLg={60} bottomMd={50} bottomLg={50} bottomXl={10}>
        <BlogSectionStyle2 data={blogs.map(b => ({ ...b, socialShare: false }))} />
      </Section>
    </>
  );
}
